var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container pt-3" }, [
    _c("img", { staticClass: "mt-5", attrs: { src: _vm.logo, height: "50" } }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "gv-container-header d-flex flex-column align-items-center pt-5 justify-content-center text-center",
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass: "btn btn-h btn-dark",
            attrs: { to: { name: "Dashboard" } },
          },
          [_vm._v("Inicio")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "display-1 text-muted" }, [
      _c("strong", [_vm._v("404")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "title" }, [
      _c("strong", [_vm._v("La pagina no fue encontrada")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-muted" }, [
      _vm._v("La página o el recurso al que intentabas acceder no esta"),
      _c("br"),
      _vm._v(" disponible por alguna razón."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }